import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, } from 'react';
import classNames from 'classnames';
import noop from 'lodash/noop';
const RadioButtonIcon = (props) => {
    const { icon, iconSize, iconLabelPosition, text } = props;
    const iconStyles = {
        width: `${iconSize}px`,
        height: `${iconSize}px`,
        fontSize: `${iconSize}px`,
        lineHeight: `${iconSize}px`,
    };
    return (_jsxs("span", { className: `radio-icon label-${iconLabelPosition}`, children: [_jsx("span", { className: `rioglyph ${icon}`, style: iconStyles }), _jsx("span", { className: 'radio-label', children: text })] }));
};
const RadioButton = (props) => {
    const { icon = '', iconLabelPosition = 'vertical', iconSize = 16, label, onClick = noop, onChange = noop, checked, defaultChecked, disabled = false, className, inline = false, right = false, custom = false, name, value, tabIndex = 0, inputRef, children, ...remainingProps } = props;
    const isControlled = checked !== null && checked !== undefined;
    const labelRef = useRef(null);
    const handleToggleKeyDown = (event) => {
        switch (event.key) {
            case ' ': // toggle on space
            case 'Enter': // open on enter
                toggle(event);
                break;
            default:
                break;
        }
    };
    const toggle = (event) => {
        event.preventDefault();
        if (disabled) {
            return;
        }
        // Controlled case - uses "onChange()" instead of "onClick()" callback
        if (isControlled) {
            onChange(event);
            return;
        }
        // Uncontrolled case - set the input checked or unchecked
        if (labelRef.current) {
            const checkbox = labelRef.current.firstChild;
            checkbox.checked = !checkbox.checked;
        }
        onClick(event);
    };
    const text = label || children;
    const labelClassnames = classNames('radio', inline && 'radio-inline', className);
    const inputClassnames = classNames(right && 'icon-right', className);
    const renderCustomIcon = !!icon;
    const renderCustomContent = custom && children;
    const renderDefault = !icon && !custom;
    return (_jsxs("label", { ...remainingProps, className: labelClassnames, tabIndex: tabIndex, onKeyDown: handleToggleKeyDown, ref: labelRef, children: [_jsx("input", { type: 'radio', defaultChecked: defaultChecked, checked: checked, disabled: disabled, className: inputClassnames, ref: inputRef, onClick: onClick, onChange: onChange, name: name, value: value }), renderCustomIcon && (_jsx(RadioButtonIcon, { icon: icon, iconSize: iconSize, iconLabelPosition: iconLabelPosition, text: text })), renderDefault && (_jsx("span", { className: 'radio-text', children: _jsx("span", { children: text }) })), renderCustomContent && children] }));
};
RadioButton.ICON_LABEL_VERTICAL = 'vertical';
RadioButton.ICON_LABEL_HORIZONTAL = 'horizontal';
export default RadioButton;
